import { render } from "./GridPo.vue?vue&type=template&id=3870f0c2"
import script from "./GridPo.vue?vue&type=script&lang=js"
export * from "./GridPo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__